import {Component, Input} from '@angular/core';
import {ChatImageViewDialogComponent, ImageType} from '../chat-image-view-dialog/chat-image-view-dialog.component';
import {PDF_ICON, TXT_ICON, WORD_ICON, XLSX_ICON} from '../../../shared/models/chatLinnegocios/icon_path';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {ImageViewerComponent} from '../image-viewer/image-viewer.component';
import {MatIconModule} from '@angular/material/icon';
import {CommonModule} from '@angular/common';
import {MatButton, MatButtonModule, MatMiniFabButton} from '@angular/material/button';

const ICONS_PATH = "assets/svg/chatFileIcons/";

@Component({
  selector: 'app-filemessage',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './filemessage.component.html',
  styleUrls: ['./filemessage.component.scss']
})
export class FilemessageComponent {
  @Input() file!: {
    fileName: string,
    contentType: string,
    url: string | '',
  };
  @Input() envia !: boolean;

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar,
  ) {
  }

  isImage(): boolean {
    return this.file.contentType.startsWith('image/');
  }

  isVideo(): boolean {
    return this.file.contentType.startsWith('video/');
  }

  whichFile(): string {
    let sourcePath = ICONS_PATH;
    switch (this.file.contentType.split('/')[1]) {
      case 'msword':
        sourcePath += WORD_ICON;
        break;
      case 'pdf':
        sourcePath += PDF_ICON;
        break;
      case 'plain':
        sourcePath += TXT_ICON;
        break;
      case 'vnd.ms-excel':
        sourcePath += XLSX_ICON;
        break;
      case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        sourcePath += XLSX_ICON;
        break;
      case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
        sourcePath += WORD_ICON;
        break;
      default:
        return '';
        break;
    }
    return sourcePath;
  }

  async download(): Promise<void> {
    try {
      if (this.file.url.startsWith('data:')) {
        const blob = await (await fetch(this.file.url)).blob();
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url; anchor.download = this.file.fileName || 'archivo';
        anchor.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
      } else window.open(this.file.url, '_blank', 'noopener,noreferrer');
    } catch (err) {
      this.snackBar.open('Error al descargar');
    }
  }

  openImages(): void {
    const image: ImageType = {
      nombre: this.file.fileName,
      url: this.file.url,
    };
    this.dialog.open(ImageViewerComponent, {
      panelClass: 'foto-dialog',
      data: image,
    });
  }

  protected readonly PDF_ICON = PDF_ICON;
}
